const API_URL = '/dashboard'

export const state = () => ({
  general_info: {},
  note: {
    createdTs: '',
    value: '',
  },
  bins_without_code: { items: [] },
  bins_not_collected: { items: [] },
  bins_out_of_route: { items: [] },
  waste_collection_forecast: {},
  waste_collection_summary: {
    totalBinCount: 0,
    totalWasteQuantity: 0,
    totalCollectionTime: 0,
    data: [],
  },
  expiring_contracts: { items: [] },
  upcoming_resource_events: { items: [] },
})

export const getters = {
  getGeneralInfo: state => {
    return state.general_info
  },
  getNote: state => {
    return state.note
  },
  getBinsWithoutCode: state => {
    return state.bins_without_code
  },
  getBinsNotCollected: state => {
    return state.bins_not_collected
  },
  getBinsOutOfRoute: state => {
    return state.bins_out_of_route
  },
  getWasteCollectionForecast: state => {
    return state.waste_collection_forecast
  },
  getWasteCollectionSummary: state => {
    return state.waste_collection_summary
  },
  getExpiringContracts: state => {
    return state.expiring_contracts
  },
  getUpcomingResourceEvents: state => {
    return state.upcoming_resource_events
  },
}

export const mutations = {
  SET_GENERAL_INFO(state, info) {
    state.general_info = info
  },
  SET_NOTE(state, note) {
    state.note = note
  },
  SET_BINS_WITHOUT_CODE(state, data) {
    state.bins_without_code = data
  },
  SET_BINS_NOT_COLLECTED(state, data) {
    state.bins_not_collected = data
  },
  SET_BINS_OUT_OF_ROUTE(state, data) {
    state.bins_out_of_route = data
  },
  SET_WASTE_COLLECTION_FORECAST(state, data) {
    state.waste_collection_forecast = data
  },
  SET_WASTE_COLLECTION_SUMMARY(state, data) {
    state.waste_collection_summary = data
  },
  SET_EXPIRING_CONTRACTS(state, data) {
    state.expiring_contracts = data
  },
  SET_UPCOMING_RESOURCE_EVENTS(state, data) {
    state.upcoming_resource_events = data
  },
}

export const actions = {
  async fetchGeneralInfo({ commit }, waste_company_branch_id) {
    let { data: generalInfo } = await useApi(`${API_URL}/${waste_company_branch_id}/general-info`)

    commit('SET_GENERAL_INFO', generalInfo.value)

    return generalInfo.value
  },
  async fetchNote({ commit }, waste_company_branch_id) {
    let { data: note } = await useApi(`${API_URL}/${waste_company_branch_id}/note`)

    commit('SET_NOTE', note.value)

    return note.value
  },
  async updateNote({ commit }, { waste_company_branch_id, noteValue }) {
    const { data, error } = await useApi(`${API_URL}/${waste_company_branch_id}/note`, {
      method: 'post',
      params: { noteValue: noteValue },
    })
    let note = { createdTs: new Date().toISOString(), noteValue: noteValue }

    if (error.value) {
      console.log('Error updating note:', error.value)
      throw new Error('Failed to update note')
    }

    commit('SET_NOTE', note)

    return note
  },
  async fetchBinsWithoutCode({ commit }, { waste_company_branch_id, params }) {
    let { data: bins } = await useApi(`${API_URL}/${waste_company_branch_id}/bin-count-collected-without-code`, {
      query: params,
    })

    commit('SET_BINS_WITHOUT_CODE', bins)

    return bins
  },
  async fetchBinsNotCollected({ commit }, { waste_company_branch_id, params }) {
    let { data: bins } = await useApi(`${API_URL}/${waste_company_branch_id}/bin-count-not-collected`, {
      query: params,
    })
    commit('SET_BINS_NOT_COLLECTED', bins.value)

    return bins.value
  },
  async fetchBinsOutOfRoute({ commit }, { waste_company_branch_id, params }) {
    let { data: bins } = await useApi(`${API_URL}/${waste_company_branch_id}/bin-count-out-of-route`, {
      query: params,
    })

    commit('SET_BINS_OUT_OF_ROUTE', bins.value)

    return bins.value
  },
  async fetchWasteCollectionForecast({ commit }, waste_company_branch_id) {
    let { data: forecast } = await useApi(`${API_URL}/${waste_company_branch_id}/waste-collection-forecast`)

    commit('SET_WASTE_COLLECTION_FORECAST', forecast.value)

    return forecast.value
  },
  async fetchWasteCollectionSummary({ commit }, { waste_company_branch_id, params }) {
    let { data: summary } = await useApi(`${API_URL}/${waste_company_branch_id}/waste-collection-summary`, {
      query: params,
    })

    commit('SET_WASTE_COLLECTION_SUMMARY', summary.value)

    return summary.value
  },
  async fetchExpiringContracts({ commit }, { waste_company_branch_id, params }) {
    let { data: expiringContracts } = await useApi(
      `${API_URL}/${waste_company_branch_id}/waste-customer-contracts-close-to-end`,
      { query: params }
    )

    commit('SET_EXPIRING_CONTRACTS', expiringContracts.value)

    return expiringContracts.value
  },
  async fetchUpcomingResourceEvents({ commit }, { waste_company_branch_id, params }) {
    let { data: events } = await useApi(`${API_URL}/${waste_company_branch_id}/upcomming-resorce-events`, {
      query: params,
    })

    commit('SET_UPCOMING_RESOURCE_EVENTS', events.value)

    return events.value
  },
}
